/*
 * 【common】共通処理
 */

//PC
function isPC(){
  return $(window).width() > 749;
}

// HOMEのURLを取得(絶対パス)
function getHomeUrl(){
	var pathname = getHomeUrlPathName();
	var url = document.location.protocol + '//' + document.location.host + pathname;
	return url;
}

// HOMEのURLを取得（pathnameからの絶対パス）
function getHomeUrlPathName(){
	var homeUrl = '/';
	return homeUrl;
}

// トップページか判定
function isPageTop(){
  var homeUrlPathName = '/';
  // 最後のスラッシュを消す（デモ環境対策）
  homeUrlPathName = homeUrlPathName.slice(0, homeUrlPathName.length-1);
  var regex = '^' + homeUrlPathName + '\/?$';
  return Util.isPageRegex(regex);
}

$(function(){
  
  //Product page
  if( $( '.template-product' ).length ){
    //「必ずお読みください」のモーダル表示
    noticeModal();
    
    //商品説明文内のテーブルタグをスクロールするためのタグを付与する処理
    var containerClass = '.product-description';
    wrapTable( containerClass );

    //商品ページ用バリエーション毎の購入数制限　※WEB_0001-14379 Dawn切替時にコメントアウト
    //LimitPurchaseQuantityProductPage();
    
    //購入上限数の表示
    ShowOrderLimitNum();
    
    //商品ページのおすすめ商品バナーの非表示処理
    hiddenProductRecommendBanner();
    
  }

  //Page page
  if( $( '.template-page' ).length ){
    //クリックでコンテンツの表示制御
    contorlDisplayContents();
  }
  
  //Article page
  if( $( '.template-article' ).length ){
    //商品説明文内のテーブルタグをスクロールするためのタグを付与する処理
    var containerClass = '.rte';
    wrapTable( containerClass );
  }

  //Cart page
  if( $( '.template-cart' ).length ){
    //カート用バリエーション毎の購入数制限
    LimitPurchaseQuantityCartPage();
  }

  
});

//商品説明文内のテーブルタグをスクロールするためのタグを付与する処理
function wrapTable( containerClass ){
  //テーブルタグがなければ処理終了
  if( $( containerClass +' table' ).length < 1 ){
    return false;
  }
  
  //tableタグを囲むclass
  var wrapClass = 'scrollable-wrapper';
  //divタグで囲む
  $( containerClass +' table' ).wrap( '<div class="'+ wrapClass +'">' );
  
}

//「必ずお読みください」のモーダル表示  
function noticeModal(){
  
  // お読みくださいmodal
  var buttonOpen = $('.js-modal');
  var modal = $('.item-modal');
  var buttonClose = $('.modal-close');
  
  //open
  buttonOpen.on('click', function(){
    modal.show();
  });
  
  //close
  buttonClose.on('click', function(){
    modal.hide();
  });
  
  $(document).on('click', function(){
    if( $( this ).target == modal ) {
      modal.hide();
    };
  });
}

//クリックでコンテンツの表示制御
function contorlDisplayContents(){
  //FAQ以外のページは処理終了
  if( $('.faq-box').length < 1 ){
    return false;
  }
  //ページ読み込み時はコンテンツを閉じておく
  $('.faq-box').addClass('is--close');
  //プラスをクリックすると、コンテンツが展開
  $('.js-faq-toggle').on('click',function(){
    $(this).parent('.faq-box').toggleClass('is--close');
  });
}

//購入上限数の表示
function ShowOrderLimitNum(){
  var orderQtyLimit = 0; // 購入上限
  var variantSelector = $('.single-option-selector'); // バリエーションのセレクタ―
  var orderLimitText = $('.js-order-limit-text'); // 購入上限の文言
  var orderQtyLimitNum;

  // バリエーションのセレクターがないときは処理終了
  if(variantSelector.length < 1) {
    return false;
  }

  // 購入上限数を取得
  orderQtyLimit = variantLimitCheck();
  orderQtyLimitNum = parseInt(orderQtyLimit);
  //購入数制限がある場合、上限数を表示
  if(orderQtyLimitNum > 0) {
    $('.js-order-limit-num').text(orderQtyLimit);
    orderLimitText.show();
  }

  // バリエーション変更時にも処理を実行
  variantSelector.on('change',function(){
    // 購入上限数を取得
    orderQtyLimit = variantLimitCheck();
    orderQtyLimitNum = parseInt(orderQtyLimit);
    //上限数を書き換え
    $('.js-order-limit-num').text(orderQtyLimit);
    //購入数制限がある場合、上限数を表示
    if(orderQtyLimitNum > 0) {
      orderLimitText.show();
    }else{
      orderLimitText.hide();
    }
  });
}

//商品ページ用バリエーション毎の購入数制限
function LimitPurchaseQuantityProductPage(){
  var cartBtn = $('.js-product-form__submit') // カートボタン;
  var orderQtyLimit = 0; // 購入上限
  var orderQtyInput = $('.js-quantity__input');
  var orderQty = $('.js-quantity__input').val(); // 購入数
  var orderLimitText = $('.js-order-limit-text'); // 購入上限の文言
  var variantSelector = $('.single-option-selector'); // バリエーションのセレクタ―

  // バリエーションのセレクターがないときは処理終了
  if(variantSelector.length < 1) {
    return false;
  }

  // カートの中身チェック
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    cache: false,
    dataType: 'json'
  })
  .then(
    // 通信成功時
    function (cart) {
      // 購入上限数を取得
      orderQtyLimit = variantLimitCheck();

      var cartItems = cart['items'] // カート内アイテム;
      // カート内の商品数チェック
      var orderCartQty = inCartItemQtyCheck(cartItems);

      // 購入制限を実行
      variantLimitControl(orderQtyLimit,orderQty,cartBtn,orderLimitText,orderCartQty);

    },
    // 通信失敗時
    function () {
      console.log("cart.js 読み込み失敗");
    }
  );

  // バリエーション変更時にも処理を実行
  variantSelector.on('change',function(){
    orderQtyLimit = variantLimitCheck();
    // カートの中身チェック
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      cache: false,
      dataType: 'json'
    })
    .then(
      // 通信成功時
      function (cart) {
        var cartItems = cart['items'] // カート内アイテム;
        // カート内の商品数チェック
        var orderCartQty = inCartItemQtyCheck(cartItems);

        // 購入制限を実行
        variantLimitControl(orderQtyLimit,orderQty,cartBtn,orderLimitText,orderCartQty);

      },
      // 通信失敗時
      function () {
        console.log("cart.js 読み込み失敗");
      }
    );

    // 上限数表示
    $('.js-order-limit-num').text(orderQtyLimit);
  });

  // 数量変更時にも処理を実行
  orderQtyInput.on('change', function(){
    orderQty = parseInt($(this).val());
    orderQtyLimit = variantLimitCheck();

    $.ajax({
      type: 'GET',
      url: '/cart.js',
      cache: false,
      dataType: 'json'
    })
    .then(
      // 通信成功時
      function (cart) {
          var cartItems = cart['items'] // カート内アイテム;
          // カート内の商品数チェック
          var orderCartQty = inCartItemQtyCheck(cartItems);

          // 購入制限を実行
          variantLimitControl(orderQtyLimit,orderQty,cartBtn,orderLimitText,orderCartQty);

      },
      // 通信失敗時
      function () {
        console.log("cart.js 読み込み失敗");
      }
    );

  });

   // エンターキーでのカート投下を無効にする
  $('form.product-form input').keypress(function(e){
    if(e.key === 'Enter') {
      return false;
    }
  });
}

// バリエーション毎の購入数制限 制限数量チェック
function variantLimitCheck() {
  var variantSelector = $('.single-option-selector'); // バリエーションのクラス
  var variantName =''; // バリエーション名
  var orderQtyLimit = 0; // 購入数上限
  variantSelector.each(function(i){
    // Liquidの出力との比較用に、バリエーションを連結してバリエーション名を作成
    i = i+1;
    variantName += $(this).val();
    if( i != variantSelector.length ){
      variantName += ' / ';
    }

    $('.hide_variant').each(function(index, element){
      // 選択したバリエーションと.hide_variantのdata-variantname属性が一致するものを検出
      if(variantName == $(this).data('variantname')) {
        // 一致したもののテキスト（order_quantity_limit）を取得
        if($(this).text() == '') {
          orderQtyLimit = 0;
        } else{
          orderQtyLimit = $(this).text();
        }
      }
    });
  });
  // 購入数上限を返す
  return parseInt(orderQtyLimit);
}

// バリエーション毎の購入数制限 購入数量制限実行
function variantLimitControl(orderQtyLimit,orderQty,cartBtn,orderLimitText,orderCartQty) {
  orderQtyLimitNum = parseInt(orderQtyLimit);
  orderQtyNum = parseInt(orderQty);
  orderCartQtyNum = parseInt(orderCartQty);

  setTimeout(function(){
    //購入数制限がある場合
    if(orderQtyLimitNum > 0) {
      orderLimitText.show();
    // 購入数上限を超えた場合、制限する
    if((orderQtyNum + orderCartQtyNum) > orderQtyLimitNum) {
        if(cartBtn.prop('disabled') == true) {
          // 品切れの場合
          cartBtn.find( 'span' ).text('ただいま品切れ中です');
        } else {
          // カートボタン利用不可
          cartBtn.prop('disabled',true);
          cartBtn.find( 'span' ).text('ご注文いただけません');
        }
      // 制限数内の場合
      } else {
        if(cartBtn.prop('disabled') == true) {
          // 品切れの場合
          cartBtn.find( 'span' ).text('ただいま品切れ中です');
        } else {
          // カートボタン利用可に
          cartBtn.prop('disabled',false);
          cartBtn.find( 'span' ).text('カートに入れる');
        }
      }
    //購入数制限がない場合
    } else {
      orderLimitText.hide();
      if(cartBtn.prop('disabled') == true) {
        // 品切れの場合
        cartBtn.find( 'span' ).text('ただいま品切れ中です');
      } else {
        // カートボタン利用可に
        cartBtn.prop('disabled',false);
        cartBtn.find( 'span' ).text('カートに入れる');
      }
    }
  }, 100);
}

// カート内の商品数チェック
function inCartItemQtyCheck(cartItems) {
  var variantSelector = $('.single-option-selector'); // バリエーションのクラス
  var variantName = $('.hide_itemid').text(); // 最終的に商品idとバリエーション名を連結
  var orderCartQty = 0; // カート内アイテム数

  // Liquidの出力との比較用に、バリエーションを連結してバリエーション名を作成
  variantSelector.each(function(i){
    i = i+1;
    variantName += $(this).val();
    if( i != variantSelector.length ){
      variantName += ' / ';
    }

    // 選択したバリエーションとカート内アイテムのバリエーションが一致するものを検出
    for (var j = 0; j < cartItems.length; j++) {
      // バリエーション名を拾ってくる
      var itemProductId = cartItems[j].product_id;
      var itemTitle = cartItems[j].title;
      var itemProductName = cartItems[j].product_title;
      var itemVariationName = itemTitle.replace(itemProductName,'').replace(/ - /g,'');
      var itemVariationNameWithId = itemProductId + itemVariationName;

      if(variantName == itemVariationNameWithId) {
        // 一致したもののカート内のアイテム数を取得
        if(cartItems[j].quantity != '') {
          orderCartQty = cartItems[j].quantity;
        }
      }
    }
  });
  //カート内の商品数を返す
  return orderCartQty;
}

//カート用バリエーション毎の購入数制限
function LimitPurchaseQuantityCartPage(){
  //カートが空っぽであれば処理終了
  if($('.cart-item').length < 1) {
    return false;
  }

  var cartRowClass = '.cart-item';//カート内の各商品
  var cartBtn = $('.cart__checkout-button');//チェックアウトボタン
  var orderLimitText = $('.js-order-limit-text');//

  // 購入数量制限
  cartVariantLimitControl(cartBtn,orderLimitText);

  // 数量変更時処理
  $('.quantity__input').on('change', function(){
    // 購入数量制限
    cartVariantLimitControl(cartBtn,orderLimitText);
  });


  // 購入フォームSubmit時に購入制限判定
  $('form.cart__contents').submit(function(){
    var cartLimit = cartVariantLimitControl(cartBtn,orderLimitText);
    // カート上限に引っかかっていたらフォーム送信停止
    if(cartLimit == true) {
      return false;
    }
  });
  // エンターキーでのカート投下を無効にする
  $('form.cart__contents input.quantity__input').keypress(function(e){
    if(e.key === 'Enter') {
      return false;
    }
  });
}

// カート用バリエーション毎の購入数制限 購入数量制限実行
function cartVariantLimitControl(cartBtn,orderLimitText) {
  setTimeout(function(){
    var limitCheck = 0; // 購入制限の判定用。0は制限なし。
    var cartLimit = false;

    // カート商品ごとにチェック
    $('.cart-item').each(function(){
      var this_row = $(this);
      var orderQtyLimit = this_row.find('.js-order-limit-num').text(); // 商品ごとの購入上限数
      // 購入上限が未設定の場合は0にする
      if(orderQtyLimit) {
        orderQtyLimitNum = parseInt(orderQtyLimit);
      } else {
        orderQtyLimitNum = parseInt(0);
      }

      var orderQty = this_row.find('.quantity__input').val(); // 商品ごとの購入数
      // 商品ごとに購入数を取得
      if(orderQty) {
        orderQtyNum = parseInt(orderQty);
      } else {
        orderQtyNum = parseInt(0);
      }

      // 購入制限フラグ
      if(orderQtyLimitNum > 0) {
        if(orderQtyNum > orderQtyLimitNum) {
          // 購入数が上限を超える場合は制限する
          limitCheck++;
          this_row.find('.js-order-limit-num-text').show();
        }
      }
    });

    // 購入制限
    if(limitCheck > 0) {
      // ひとつでも購入制限フラグがあれば購入制限を実施
      orderLimitText.show(); // 購入上限の説明テキスト
      cartBtn.prop('disabled',true); // ボタン利用不可
      cartBtn.val('ご注文いただけません'); // ボタンの文言変更
      $('.cart__checkout-button').hide(); // カートボタンを隠す
      $('.js-order-limit-dummy-btn').show(); // ダミーボタン（購入不可文言）を表示
      $('.cart__dynamic-checkout-buttons').hide();//アマペイボタンの非表示
      cartLimit = true;
      return cartLimit;
    } else {
      // 購入制限フラグがなければカートを利用可に
      orderLimitText.hide();
      cartBtn.prop('disabled',false);
      cartBtn.val('ご注文手続きへ');
      $('.cart__checkout-button').show();
      $('.js-order-limit-dummy-btn').hide();
      $('.cart__dynamic-checkout-buttons').show();
      cartLimit = false;
      return cartLimit;
    }

  }, 200);
}

//商品ページのおすすめ商品バナーの非表示処理
function hiddenProductRecommendBanner(){
  $( '.product__recommend-banner-close' ).on( 'click', function(){
    $( '.product__recommend-banner' ).hide();
  });
}


